const storage = {
    not_configured: 'ストレージプロバイダが設定されていません。',
    missing_parameter: 'ストレージプロバイダの{{parameter}}が欠落しています。',
    upload_error: 'ファイルのアップロードに失敗しました。',
};
export default Object.freeze(storage);
